module.exports = __webpack_public_path__ + "img/brand-19.209c78b7.png";